import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import GenericTile from '@atlaskit/tile/tile';
import type { TileProps } from '@atlaskit/tile/types';
import { ResourceType } from '@atlassian/search-client/third-party-graph-entity';

import { getGoogleDriveFileTypeIcon } from '../../constants/3p-product-configs/google/file-type-icon';
import { getSharePointFileTypeIcon } from '../../constants/3p-product-configs/sharepoint/file-type-icon';
import { ProductKeys } from '../../constants/product-keys';
import { LoomVideoGlyph } from './loom-video-glyph';

export const getFileTypeIconFor3P = (
	productKey: string,
	resourceType: string,
	subtype: string | null | undefined,
): (() => React.JSX.Element) | null => {
	switch (productKey) {
		case ProductKeys.GoogleDrive:
			// Remove the Google Drive file-type icons when cleaning up this gate.
			return fg('rovo_fps_use_google_drive_product_icon')
				? null
				: getGoogleDriveFileTypeIcon(subtype);
		case ProductKeys.Sharepoint:
			// Remove the SharePoint file-type icons when cleaning up this gate.
			return fg('rovo_fps_use_sharepoint_product_icon') ? null : getSharePointFileTypeIcon(subtype);
		case ProductKeys.Loom:
			return resourceType === ResourceType.VIDEO && fg('loom-rovo-search') ? LoomVideoGlyph : null;
		default:
			return null;
	}
};

type FileTypeIconTileProps = {
	Glyph: () => React.JSX.Element;
	label: string;
	size?: TileProps['size'];
};

/**
 * Renders a 3P file-type glyph wrapped in `GenericTile`.
 */
export const FileTypeIconTile = ({
	Glyph,
	label,
	size = 'medium',
}: FileTypeIconTileProps): React.JSX.Element => (
	<GenericTile label={label} size={size}>
		<Glyph />
	</GenericTile>
);
